import React from 'react';
import PropTypes from 'prop-types';
import { localsMessages } from '../utility/getTemplateData';
import { Button } from '@paypalcorp/pp-react';
const messages = localsMessages('guest/guestButton');

class GuestButton extends React.Component {
  render() {
    const { label: { debitorcredit = '' } = {} } = messages;
    return (
      <div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
        <Button
          secondary
          className="btn-wide"
          id="payWithGuest"
          disabled={this.props.disabled}
          onClick={this.props.handleGuest}
        >
          {debitorcredit}
        </Button>
      </div>
    );
  }
}

GuestButton.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  handleGuest: PropTypes.func,
};

export default GuestButton;
